"use client";

import { environments } from "@/lib/config";
import { isEmptyObject } from "@/lib/utils";
import { useUser } from "@/stores/user";
import { MenuType } from "@/types/common";
import { UserType } from "@/types/user";
import Link from "next/link";
import { DropdownMenu } from "./DropdownMenu";
import { DropdownProfile } from "./DropdownProfile";
import LocaleSwitcher from "./LocaleSwitcher";
import NotificationBell from "./NotificationBell";

const authServerUrl = environments.authServerUrl;

interface UserNavProps {
  labels: Record<string, string>;
  navigation: MenuType[];
}

export default function UserNav({ labels, navigation }: UserNavProps) {
  const { userInfo } = useUser();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const userData = (userInfo as any)?.user as UserType;

  return (
    <>
      {isEmptyObject(userInfo?.user) ? (
        <>
          {" "}
          <div className="flex-1 flex justify-end space-x-7">
            <Link
              className="text-primary text-nowrap font-semibold"
              href={authServerUrl ?? "/"}
              data-testid="login-button"
            >
              {labels.signIn}
            </Link>
            <Link
              className="text-primary-500 text-nowrap font-semibold"
              href={"/user/select-member-type"}
              prefetch={false}
            >
              {labels.signUp}
            </Link>
          </div>
          <div>
            <LocaleSwitcher />
          </div>
        </>
      ) : (
        <div className="flex-1 flex space-x-7">
          <div className="flex-1 text-gray-900 -my-4 flex space-x-7 items-center">
            <DropdownMenu data={navigation} />
          </div>
          <div className="flex space-x-5">
            <NotificationBell />
            <div className="h-9 flex items-center text-accent-foreground">
              <DropdownProfile userInfo={userData} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
